import { ICopyable } from '../controls/common/icopyable';
import { IBox } from './interfaces/box.interface';
import { IDisplayableItem } from './interfaces/displayable-item.interface';
import { ISortable } from './interfaces/sortable.interface';

export class Box implements ICopyable<Box>, ISortable, IDisplayableItem {
    id: string = null;
    name: string = null;
    order: number = null;
    groupId: string = null;
    groupName: string = null;
    viewId: number = null;

    get editableId(): string | number {
        return this['id'];
    }

    public createCopy(): Box {
        const instance = new Box();
        instance.id = this.id;
        instance.name = this.name;
        instance.order = this.order;
        instance.groupId = this.groupId;
        instance.groupName = this.groupName;
        instance.viewId = this.viewId;

        return instance;
    }

    public static createFormCopy(box: Box): IBox {
        const instance = new Box();
        instance.id = box.id;
        instance.name = box.name;
        instance.order = box.order;
        instance.groupId = box.groupId;
        instance.groupName = box.groupName;
        instance.viewId = box.viewId;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.name = other.name;
        this.order = other.order;
        this.groupId = other.groupId;
        this.groupName = other.groupName;
        this.viewId = other.viewId;
    }

    public getDisplayName() {
        return `${this.name}`;
    }

    get displayName(): string {
        return `${this.name} (${this.groupName})`;
    }
}
